import type { DropClient } from './contract';
import { DropCore } from './client';

export { DropCore } from './client';
export * from './contract';

/**
 * Creates the Drop client engine.
 * If the URL has `?mock=1`, lazily delegates to the mock client.
 */
export function createDropClient(): DropClient {
  if (
    typeof location !== 'undefined' &&
    new URLSearchParams(location.search).get('mock') === '1'
  ) {
    const fallback = new DropCore();
    const loaders = import.meta.glob<{
      createMockClient?: () => DropClient;
      default?: () => DropClient;
    }>('./mock.ts');
    const promise =
      loaders['./mock.ts']?.() ??
      Promise.reject(new Error('Mock client is unavailable'));
    let loaded: DropClient | undefined;
    void promise
      .then((module) => {
        loaded = module.createMockClient?.() ?? module.default?.();
      })
      .catch(() => undefined);

    return new Proxy(fallback, {
      get(target, property, receiver) {
        const value = loaded
          ? Reflect.get(loaded, property, loaded)
          : Reflect.get(target, property, receiver);
        return typeof value === 'function'
          ? value.bind(loaded ?? target)
          : value;
      },
    }) as unknown as DropClient;
  }
  return new DropCore();
}

declare global {
  interface Window {
    __drop?: DropClient;
  }
}
